/* unplugin-vue-components disabled */import { ElPagination as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import { ElTable as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table-column/style/css';
import { ElButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  style: {
    "display": "felx",
    "align-items": "center",
    "margin-top": "-10px",
    "width": "100%"
  }
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
var _hoisted_3 = {
  style: {
    "margin": "10px 0",
    "width": "95%"
  }
};
var _hoisted_4 = {
  class: "pagination_"
};
import { reactive, watchEffect } from 'vue';
import { get_bd_material } from '@/api/apis.js';
export default {
  __name: 'material',
  emits: ['getSelectData'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var currentRow = ref();
    var emit = __emit;
    var data = reactive({
      list: [],
      //物料列表
      page: 1,
      limit: 10,
      total: 0,
      key_word: '',
      //关键词搜索
      checked_id: ''
    });
    // 获取数据
    var getList = () => {
      var obj = {
        page: data.page,
        limit: data.limit,
        key_word: data.key_word,
        material_group_type: 2 //1=原料 2=产品
      };
      get_bd_material(obj).then(res => {
        data.list = res.data.list;
        data.total = res.data.total;
      });
    };
    getList();
    var handleCurrentChange = val => {
      currentRow.value = val;
    };
    // 确定
    var handle_confirm = () => {
      // 向附件传递当前选中数据
      emit("getSelectData", currentRow.value);
    };

    // 查询
    var handle_search = () => {
      data.page = 1;
      getList();
    };
    return (_ctx, _cache) => {
      var _component_el_input = __unplugin_components_0;
      var _component_el_button = __unplugin_components_1;
      var _component_el_table_column = __unplugin_components_2;
      var _component_el_table = __unplugin_components_3;
      var _component_el_pagination = __unplugin_components_4;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
        style: {
          "width": "80%"
        },
        modelValue: data.key_word,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.key_word = $event),
        placeholder: "规格型号、物料名称",
        clearable: ""
      }, null, 8, ["modelValue"]), _cache[3] || (_cache[3] = _createTextVNode("  ")), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handle_search
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("查询")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
        "highlight-current-row": "",
        onCurrentChange: handleCurrentChange,
        border: "",
        data: data.list,
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "物料名称"
        }), _createVNode(_component_el_table_column, {
          prop: "code",
          label: "物料编码"
        }), _createVNode(_component_el_table_column, {
          prop: "model",
          label: "规格型号"
        }), _createVNode(_component_el_table_column, {
          prop: "material_group_name",
          label: "物料分组"
        })]),
        _: 1
      }, 8, ["data"])]), _unref(currentRow) ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: handle_confirm,
        class: "iconfont icon-ziyuan165 blk_link",
        style: {
          "font-size": "30px",
          "display": "inline-block",
          "margin": "0 10px"
        }
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
        "current-page": data.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => data.page = $event),
        background: "",
        layout: "total,prev, pager, next",
        "page-size": data.limit,
        total: data.total,
        onCurrentChange: getList
      }, null, 8, ["current-page", "page-size", "total"])])]);
    };
  }
};